import { render } from "./DailyDispatch.vue?vue&type=template&id=5bb246bc&ts=true"
import script from "./DailyDispatch.vue?vue&type=script&lang=ts"
export * from "./DailyDispatch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__